module.exports = __webpack_public_path__ + "static/media/audience.955113e2.svg";